import React from 'react'
import { connect } from 'react-redux'
import Regions from '../components/regions'

const mapStateToProps = (state) => ({
  ...state.regions
})

const mapDispatchToProps = dispatch => ({
  onCreate: payload => dispatch({type: 'REGIONS.CREATE', payload}),
  onUpdate: payload => dispatch({type: 'REGIONS.UPDATE', payload}),
  onDelete: payload => dispatch({type: 'REGIONS.DELETE', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(Regions)
